const newspapers = `Do we still need newspapers when we have the internet? Some people say yes, some say no. 
It's important to think about it.
The internet has changed how we get information. 
This has had consequences for newspapers. 
Some people don't buy newspapers anymore because they can read news online. 
This has made it harder for newspapers to make money, and some have even closed.
To help newspapers, people can still buy them and support local journalism. 
This can help keep people informed about what's happening in their area.
There are good and bad things about online magazines. 
They can give us news quickly, but sometimes it's hard to know if it's true. 
They can also have a lot of advertisements, which can be annoying.
In the future, things might change even more.
Maybe more people will read news online, and newspapers might become less common. 
But it's important to have good journalism, whether it's in newspapers or online, so we can stay informed and know what's happening in the world.`;

export default newspapers;